package com.dignicate.web.ui.components

import androidx.compose.runtime.Composable
import com.dignicate.web.css.ColorValue
import com.dignicate.web.css.ThemeVar
import com.dignicate.web.css.color
import com.dignicate.web.css.lineHeightUnitless
import com.dignicate.web.css.marginXAuto
import com.dignicate.web.domain.ProductInfo
import com.dignicate.web.theme.LocalIsDark
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@Composable
fun ProductsSection(products: List<ProductInfo>, title: String, description: String) {
    val isDark = LocalIsDark.current

    Section(attrs = { id("products"); classes("section") }) {
        Div(attrs = { classes("container") }) {
            H2({ style { fontSize(36.px); fontWeight("700"); marginBottom(12.px); textAlign("center") } }) {
                Text(title)
            }

            P({ style { maxWidth(720.px); marginXAuto(40.px); textAlign("center"); lineHeightUnitless(1.6); color(ColorValue.Var(ThemeVar.Muted)) } }) {
                Text(description)
            }

            Div(attrs = { classes("cards-grid") }) {
                products.forEach { p ->
                    Article(attrs = { classes("service-card") }) {
                        // Body: existing content moved into a growable body container
                        Div(attrs = { classes("card-body") }) {
                            H3(attrs = { classes("card-title") }) { Text(p.title) }
                            P({ style { color(ColorValue.Var(ThemeVar.Muted)); lineHeightUnitless(1.6); marginBottom(16.px) } }) { Text(p.description) }
                        }

                        // Footer: show badges when links are present (Android/iOS)
                        if (p.androidLink != null || p.iosLink != null) {
                            Div(attrs = { classes("card-footer") }) {
                                Div(attrs = { classes("store-badges") }) {
                                    // Google Play badge (shown when androidLink exists)
                                    if (p.androidLink != null) {
                                        A(href = p.androidLink, attrs = {
                                            attr("target", "_blank")
                                            attr("rel", "noopener noreferrer")
                                            attr("aria-label", "Open in Google Play")
                                            classes("store-badge-link")
                                        }) {
                                            Img(src = "/assets/store/app-google.svg", attrs = {
                                                classes("store-badge")
                                                attr("alt", "Get it on Google Play")
                                            })
                                        }
                                    }

                                    // Apple App Store: show only when iosLink exists; src switches with theme
                                    if (p.iosLink != null) {
                                        val appleSrc = if (isDark) "/assets/store/app-apple-dark.svg" else "/assets/store/app-apple-light.svg"
                                        A(href = p.iosLink, attrs = {
                                            attr("target", "_blank")
                                            attr("rel", "noopener noreferrer")
                                            attr("aria-label", "Open in the App Store")
                                            classes("store-badge-link")
                                        }) {
                                            Img(src = appleSrc, attrs = {
                                                classes("store-badge")
                                                attr("alt", "Download on the App Store")
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
